import React, { useEffect, useState } from 'react';
import './Dashstats.css';
import { Link } from 'react-router-dom';
import Tablecard from '../../Components/Tablecard/Tablecard';

function Dashstats() {

    const [allpro, setAllpro] = useState([]);
    const [allforord, setAllforord] = useState([]);
    const [allamaz, setAllamaz] = useState([]);
    const [allwhat, setAllwhat] = useState([]);
    const [allwebs, setAllwebs] = useState([]);
    const [mostlovedpro, setMostlovedpro] = useState([]);
    const [allorders, setAllorders] = useState([]);
    const [ordercount, setOrdercount] = useState(0);
    const [allorderpros, setAllorderpros] = useState([]);
    const [totalsale, setTotalsale] = useState(0);
    const [estimatesale, setEstimatesale] = useState(0);
    const [mostobj, setMostobj] = useState({});
    const [mostviewed, setMostviewed] = useState([]);
    const [allprowithnum, setAllprowithnum] = useState([]);
    const [prodata, setProdata] = useState([]);

    useEffect(() => window.scrollTo(0, 0), []);

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/`).then(res => res.json()).then(data => {
            console.log(data);
            if(data.success){
                setAllpro(data.pro);
                const mostviews = data.pro.sort((a, b) => b.views.length - a.views.length).slice(0, 10);
                setMostviewed(mostviews);
            }
        }).catch(err => console.log('error occured while getting all the product ', err));
    }, []);
    useEffect(() => {
        fetch(`https://pentadeco.in/api/allorders`).then(res => res.json()).then(data => {
            if(data.success){
                setAllorders(data.pro);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the orders ', err));
    }, []);
    useEffect(() => {
        fetch(`https://pentadeco.in/api/ordercount`).then(res => res.json()).then(data => {
            if(data.success){
                setOrdercount(data.total);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the orders ', err));
    }, []);
    useEffect(() => {
        fetch(`https://pentadeco.in/api/leads`).then(res => res.json()).then(data => {
            if(data.success){
                setAllwebs(data.pro)
                console.log(data);
            }else{
                console.log('success is not true ', data);
            }
        }).catch(err => console.log("error occured while getting all the leads ", err));
    }, []);
    useEffect(()=> {
        fetch(`https://pentadeco.in/api/fororders`).then(res => res.json()).then(data => {
            console.log(data);
            if(data.success){
                setAllforord(data.pro);
            }
        }).catch(err => console.log('error occured while getting all the product ', err));
    }, []);
    useEffect(()=> {
        fetch(`https://pentadeco.in/api/salereport`).then(res => res.json()).then(data => {
            console.log(data);
            if(data.success){
                setTotalsale(data.totalSales);
                setEstimatesale(data.estimateSales);
            }
        }).catch(err => console.log('error occured while getting all the product ', err));
    }, []);
    useEffect(() => {
        setAllamaz(allforord.filter(e => e.platform.toLowerCase() === 'amazon'));
        setAllwhat(allforord.filter(e => e.platform.toLowerCase() === 'whatsapp'));
    }, [allforord]);

    useEffect(() => {
        const allids = allforord?.map(pro => pro.productid);
        // const allids = [];
        // const webleads = allwebs?.map(pro => pro.proid);
        const someArr = [];
        allorders?.forEach(ord => {
            const something = ord?.products.flatMap(product =>
                Array(product.quantity).fill(product.proid)
            );
            someArr.push(...something);
        })
        allids.push(...someArr);
        setAllprowithnum([...someArr]);
        const frequencymap = {};
        let maxcount = 0;
        let mostfrequentmap = null;
        allids.forEach(pro => {
            frequencymap[pro] = (frequencymap[pro] || 0) + 1;
            if(frequencymap[pro] > maxcount){
                maxcount = frequencymap[pro];
                mostfrequentmap = pro;
            }
        });
        // console.log(frequencymap);
        const sortedpros = Object.entries(frequencymap).sort((a,b) => b[1] - a[1]).slice(0, 10).map(pro => pro[0]);
        console.log(mostfrequentmap);
        setMostobj(frequencymap)
        // console.log(frequencymap)
        // console.log(sortedpros);
        const topThreepros = async () => {
            const topthreepros = await Promise.all(sortedpros?.map(pro => fetch(`https://pentadeco.in/api/pro/${pro}`).then(res => res.json()).then(data => data.pro))).catch(err => console.log('error occured while getting the most loved product ', err));
            setMostlovedpro(topthreepros);
        };
        topThreepros();
    }, [allforord, allwebs, allorders])

    // useEffect(() => console.log(mostlovedpro), [mostlovedpro]);
    // useEffect(() => console.log('this is the most obj', mostobj), [mostobj]);

    useEffect(() => {
        if(allprowithnum && allprowithnum?.length > 0){
            // const allorderproids = [];
            // allorders.forEach(ord => {
            //     console.log(ord)
            //     ord.products.forEach((pro, ind) => {
            //         allorderproids.push(pro.proid);
            //     })
            // });
            // console.log('allorderproids', allorderproids);

            // const getallpros = async () => {
            //     const allpros = await Promise.all(allprowithnum?.map(id => fetch(`https://pentadeco.in/api/pro/${id}`).then(res => res.json()).then(data => data.pro))).catch(err => console.log("error occured while getting all the pros for price ", err));
            //     setAllorderpros(allpros);
            // }

            const ordpros = [];
            allprowithnum?.forEach(id => {
                allpro?.forEach(pro => {
                    if(id === pro.proid){
                        ordpros.push(pro);
                    }
                })
            });
            setAllorderpros(ordpros);

            // getallpros();
        }
    }, [allprowithnum, allpro]);

    useEffect(() => {
        if(allorderpros && allorderpros?.length > 0){
            let pricecount = 0;
            allorderpros.forEach((pro, ind) => {
                pricecount += pro.discountprice;
                // console.log(pro.discountprice, ind);
            });
            // console.log('this is the total sales price ',pricecount);
            setTotalsale(pricecount);
        }
    }, [allorderpros])

    const splitFunc = (str)=> {
        if(str){
            const imgFst = str.split(',');
            return imgFst;
        }
    }

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/bestsellers`).then(res => res.json()).then(data => {
            if(data.success){
                setProdata(data.products);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the pros ', err));
    }, []);

  return (
    <div className='main-dashstats'>
        <div className="container-fluid">
            <h2 className="body-font-bold fs-3 mt-3">Dashboard</h2>
            <div className="row p-0 m-0">
                <div className="col-md-3 col-6 p-2">
                    <Link to='products' className='nav-link'>
                        <div className="bg-brand-light rounded-brand py-3 px-3">
                            <div className="d-flex align-items-center">
                                <p className="fs-1 mb-0 lh-sm me-3"><i className="fas fa-box"></i></p>
                                <div>
                                    <p className="mb-0 lh-sm fs-4 body-font-semibold">{allpro?.length}</p>
                                    <p className="stat-txt mb-0 lh-sm body-font-bold text-muted">PRODUCTS</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* <div className="col-md-3 col-6 p-2">
                    <Link to="leads" className="nav-link">
                        <div className="bg-brand-light rounded-brand py-3 px-3">
                            <div className="d-flex align-items-center">
                                <p className="fs-1 mb-0 lh-sm me-3"><i className="fas fa-globe"></i></p>
                                <div>
                                    <p className="mb-0 lh-sm fs-4 body-font-semibold">{allwebs?.length}</p>
                                    <p className="stat-txt mb-0 lh-sm body-font-bold text-muted">VISITS</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div> */}
                <div className="col-md-3 col-6 p-2">
                    <Link to="orders" className="nav-link">
                        <div className="bg-brand-light rounded-brand py-3 px-3">
                            <div className="d-flex align-items-center">
                                <p className="fs-1 mb-0 lh-sm me-3"><i className="fas fa-clipboard-check"></i></p>
                                <div>
                                    <p className="mb-0 lh-sm fs-4 body-font-semibold">{ordercount}</p>
                                    <p className="stat-txt mb-0 lh-sm body-font-bold text-muted">ORDERS</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-md-3 col-6 p-2">
                    <div className="nav-link">
                        <div className="bg-brand-light rounded-brand py-3 px-3">
                            <div className="d-flex align-items-center">
                                <p className="fs-1 mb-0 lh-sm me-3"><i className="fas fa-rupee-sign"></i></p>
                                <div>
                                    <p className="mb-0 lh-sm fs-4 body-font-semibold">{estimatesale}</p>
                                    <p className="stat-txt mb-0 lh-sm body-font-bold text-muted">Estimate Sales</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-6 p-2">
                    <div className="nav-link">
                        <div className="bg-brand-light rounded-brand py-3 px-3">
                            <div className="d-flex align-items-center">
                                <p className="fs-1 mb-0 lh-sm me-3"><i className="fas fa-rupee-sign"></i></p>
                                <div>
                                    <p className="mb-0 lh-sm fs-4 body-font-semibold">{totalsale}</p>
                                    <p className="stat-txt mb-0 lh-sm body-font-bold text-muted">SALES</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="top-pros mt-5">
                <h2 className="fs-5 body-font-bold pb-3">Top Ten Products</h2>
                <div className="top-pros-wrap">   
                    {
                        prodata?.map((pro, ind) => (
                            <Link to={`/${pro.proid}/${pro.name.toLowerCase().replaceAll(" ", "-")}`} key={ind} className="nav-link mb-3">
                                <div className="border rounded-brand p-2 d-flex align-items-center">
                                    <img src={pro.images[0]} alt="product" width={60} style={{aspectRatio: '1/1', objectFit: 'cover', borderRadius: '10px', marginRight: '10px'}} />
                                    <div>
                                        <p className="mb-0 text-muted fs-sm lh-sm">{pro.proid}</p>
                                        <p className="mb-0 body-font-semibold lh-sm">{pro.name}</p>
                                        <p className="mb-0 body-font-semibold fs-sm lh-sm">₹{pro.discountprice}</p>
                                    </div>
                                </div>
                            </Link>
                        ))
                    }
                </div>
            </div>
        </div>
    </div>
  )
}

export default Dashstats;